import { gql } from '@apollo/client';

export const deleteHubMemberCohortById_Name = 'DeleteHubMemberCohortById';
export const deleteHubMemberCohortById_Gql = gql`
  mutation DeleteHubMemberCohortById($hubMemberCohortId: ID!) {
    deleteHubMemberCohortById(hubMemberCohortId: $hubMemberCohortId)
  }
`;
